import React, {useState} from "react";
import * as S from "./Consentpopup.styles";
import Modal from "../../../../../../core-components/generic-modal-component/GenericModal";
import Icon from "../../../../../stories/core-components/IconsSelector";

interface IContent {
  title: string;
  content: Array<string>;
}

interface IConsentPopup {
  c_t: string;
  content: Array<IContent>;
  cta: string;
  s_t: string;
  title: string;
  onConsentPopClick: () => {}
}



const ConsentPopup: React.FC<IConsentPopup> = ({
  c_t = "",
  content = [],
  cta = "",
  s_t = "",
  title = "",
  onConsentPopClick = () => {}
}) => {
  const [showReadMore, setReadMore] = useState(true);
  if (!title && !content?.length && !cta) return null;
  return (
    <Modal
      isOpen={true}
      onCloseModal={() => { }}
      modalStyles={{
        width: "70rem",
        padding: "3.3rem 2.4rem 3rem",
        borderRadius: "1.6rem"
      }}
      newModalStyles={{
        opacity: "0.8",
        boxShadow: "0 0 6px 0 rgba(0, 0, 0, 0.43)",
        backgroundColor: 'rgba(8, 8, 8, 0.95)'
      }}
      childStyles={{
        overflow: ''
      }}
    >
      <>
        <S.StyledModalHeader>
          <S.SectionHeader>{title}</S.SectionHeader>
          <S.StyledIcon onClick={()=> onConsentPopClick(false)}>
            <Icon name="ClosePopupIcon" />
          </S.StyledIcon>
        </S.StyledModalHeader>
        <S.ListWrapper>
        {content?.map(({ title: t = "", content: ct = [] }) => (
          <S.Styling>
            <S.HeaderTxt>{t}</S.HeaderTxt>
            {ct?.map((data) => (
              <S.LiWrapper>
                <S.Dot></S.Dot>
                <S.LiTxt>{data}</S.LiTxt>
              </S.LiWrapper>
            )) || null}
          </S.Styling>
        )) || null}
      </S.ListWrapper>
        <S.StylingDiv>
          {/* {showReadMore ? <S.ReadMoreTxt onClick={() => setReadMore(false)}>Read more</S.ReadMoreTxt> : null} */}
          <S.BtnWrapper>
            <S.Bar>
              <S.Bartxt>{c_t}</S.Bartxt>
            </S.Bar>
            <S.Bar bc={'#ff6d38'} ai={'center'}  jc={'center'} margin={'0 0 1.4rem 0'} onClick={()=> onConsentPopClick(true)}>
              <S.Btntxt>{cta}</S.Btntxt>
            </S.Bar>
          </S.BtnWrapper>
        </S.StylingDiv>
      </>
    </Modal>
  );
};

export default ConsentPopup;
